export const range = (length: number): number[] => [...new Array(length).keys()];
